export default __webpack_public_path__ + "static/media/background.b533d7ec.svg";